export function easterEgg() {
  window.open("https://www.youtube.com/watch?v=wycjnCCgUes", "_blank");
}
